import styled from 'styled-components';
import { primitives } from '@veneer/primitives';
import {
  layout,
  minDesktopLarge,
  minDesktopRegular,
  minDesktopSmall,
  minDesktopXS,
  minMobile,
  minTablet,
  paddingDesktopLarge,
  paddingDesktopRegular,
} from '../../GlobalStylesVisid';

const { color } = primitives;
const { gray0 } = color;
const { size2, size4, size6, size8 } = layout;

export const Container = styled.div`
  background-color: ${gray0};
  padding: 40px ${size4}px 48px ${size4}px;

  ${minMobile} {
    padding: 40px ${size4}px 48px ${size4}px;
  }
  ${minTablet} {
    padding: 48px ${size8}px 60px ${size8}px;
  }
  ${minDesktopXS} {
    padding: 80px ${size8}px 100px ${size8}px;
  }
  ${minDesktopSmall} {
    padding: 80px 48px 100px 48px;
  }
  ${minDesktopRegular} {
    padding-left: ${paddingDesktopRegular};
    padding-right: ${paddingDesktopRegular};
  }
  ${minDesktopLarge} {
    padding: 80px ${paddingDesktopLarge} 100px ${paddingDesktopLarge};
  }
`;

export const Title = styled.h2`
  margin-bottom: ${size6}px;
  color: #1a1a1a;

  ${minTablet} {
    margin-bottom: 40px;
  }
`;

export const StyledParagraph = styled.p`
  color: #636363;
  margin: 0;
  padding: 0;
  min-width: ${size4}px;
`;

export const StyledIndex = styled(StyledParagraph)`
  text-align: end;
  min-width: 25px;
`;

export const ListContainer = styled.div`
  display: flex;
  align-items: start;
  gap: ${size2}px;
`;
